import {Box, Chip, InputLabel, MenuItem, Select} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {memo} from "react";

const MhdMultiSelect = ({ label, value, onChange, choices }) => {
  const theme = useTheme();
  const handleChange = (event) => {
    const {target: { value: selectedValues },} = event;
    // onChange(prevData => ({...prevData, [name]: typeof selectedValues === 'string' ? selectedValues.split(',') : selectedValues}));
    onChange(typeof selectedValues === 'string' ? selectedValues.split(',') : selectedValues)
  };
  //   const handleChange = (event) => {
  //   const {
  //     target: { value: selectedValues },
  //   } = event;
  //   setter(
  //     name,
  //     typeof selectedValues === 'string' ? selectedValues.split(',') : selectedValues
  //   );
  // };

  return (
    <>
      <InputLabel variant='primary'>
        {label}
      </InputLabel>
        <Select
          multiple
          value={value}
          onChange={handleChange}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
              {selected.map((value) => {
                const selectedChoice = choices.find(choice => choice.value === value);
                return <Chip key={value} label={selectedChoice ? selectedChoice.label : value} sx={{height: '20px'}} />;
              })}
            </Box>
          )}
          sx={{height: '100%'}}
        >
          {choices.map((choice) => (
            <MenuItem
              key={choice.value}
              value={choice.value}
              aria-label={choices.label}
            >
              {choice.label}
            </MenuItem>
          ))}
        </Select>
    </>
  );
}

export default memo(MhdMultiSelect);